import _ from 'lodash';
window._ = _;

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

import axios from 'axios';
window.axios = axios;

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

function isLocalhost(url) {
    return url.includes('localhost') || url.includes('127.0.0.1');
}

import Bugsnag from '@bugsnag/js';

if (process.env.MIX_APP_ENV === 'production' 
    || process.env.MIX_APP_ENV === 'dev' && !isLocalhost(window.location.href)) {
        
        Bugsnag.start({ 
            apiKey: process.env.MIX_BUGSNAG_API_KEY,
            onError: function (event) {
                event.setUser(window.user.id, window.user.email, window.user.name);
            } 
        });

        Bugsnag.releaseStage = process.env.MIX_APP_ENV;
        Bugsnag.notifyReleaseStages = ['production', 'dev'];
        
        window.Bugsnag = Bugsnag;
}



// import Echo from 'laravel-echo';

// import Pusher from 'pusher-js';
// window.Pusher = Pusher;

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: import.meta.env.VITE_PUSHER_APP_KEY,
//     wsHost: import.meta.env.VITE_PUSHER_HOST ?? `ws-${import.meta.env.VITE_PUSHER_APP_CLUSTER}.pusher.com`,
//     wsPort: import.meta.env.VITE_PUSHER_PORT ?? 80,
//     wssPort: import.meta.env.VITE_PUSHER_PORT ?? 443,
//     forceTLS: (import.meta.env.VITE_PUSHER_SCHEME ?? 'https') === 'https',
//     enabledTransports: ['ws', 'wss'],
// });
